import React from "react"
import { useIntl } from "gatsby-plugin-react-intl"

const BookButton = ({ hotelId, locale }) => {
  const intl = useIntl()

  // switch (hotelId) {
  //   case "0a860d53-0e43-4723-bebc-e4144174a4a2":
  //     return locale === "en" ? (
  //       <a
  //         className="btn btnLight"
  //         target="_blank"
  //         href="https://reservations.veranda-resorts.com/?hotel=59976&amp;chain=14463&amp;themeCode=TELFAIRTHEME&amp;configCode=new_BE&amp;locale=en-US"
  //       >
  //         <span>Book now</span>
  //       </a>
  //     ) : (
  //       <a
  //         className="btn btnLight"
  //         target="_blank"
  //         href="https://reservations.veranda-resorts.com/?hotel=59976&amp;chain=14463&amp;themeCode=TELFAIRTHEME&amp;configCode=new_BE&amp;locale=fr-FR"
  //       >
  //         <span>Réserver</span>
  //       </a>
  //     )
  //   case "84d7e9a8-d840-40da-b0c1-acc1fbf40545":
  //     return locale === "en" ? (
  //       <a
  //         className="btn btnLight"
  //         href="https://reservations.veranda-resorts.com/?hotel=59973&amp;chain=14463&amp;themeCode=HRA&amp;configCode=HRA&amp;locale=en-US"
  //         target="_blank"
  //       >
  //         <span>Book now</span>
  //       </a>
  //     ) : (
  //       <a
  //         className="btn btnLight"
  //         href="https://reservations.veranda-resorts.com/?hotel=59973&amp;chain=14463&amp;themeCode=HRA&amp;configCode=HRA&amp;locale=fr-FR"
  //         target="_blank"
  //       >
  //         <span>Réserver</span>
  //       </a>
  //     )
  //   case "e9a09b4c-d930-454f-9a91-9f755892f127":
  //     return locale === "en" ? (
  //       <a
  //         className="btn btnLight"
  //         href="https://reservations.veranda-resorts.com/?hotel=59995&amp;chain=14463&amp;themeCode=HRTV&amp;configCode=HRTV&amp;locale=en-US"
  //         target="_blank"
  //       >
  //         <span>Book now</span>
  //       </a>
  //     ) : (
  //       <a
  //         className="btn btnLight"
  //         href="https://reservations.veranda-resorts.com/?hotel=59995&amp;chain=14463&amp;themeCode=HRTV&amp;configCode=HRTV&amp;locale=fr-FR"
  //         target="_blank"
  //       >
  //         <span>Réserver</span>
  //       </a>
  //     )
  //   default:
  //     return locale === "en" ? (
  //       <a
  //         href="https://reservations.veranda-resorts.com/?chain=14463&amp;dest=HERITAGE&amp;themecode=HR&amp;configCode=HRT&amp;adult=2&amp;locale=en-US"
  //         target="_blank"
  //         className="btn btnLight"
  //       >
  //         <span>Book now</span>
  //       </a>
  //     ) : (
  //       <a
  //         href="https://reservations.veranda-resorts.com/?chain=14463&amp;dest=HERITAGE&amp;themecode=HR&amp;configCode=HRT&amp;adult=2&amp;locale=fr-FR"
  //         target="_blank"
  //         className="btn btnLight"
  //       >
  //         <span>Réserver</span>
  //       </a>
  //     )
  // }

  //Handle Booking Layout
  const toggleBookingForm = () => {
    const contBookingBlock = document.querySelector(".bookingBar")
    contBookingBlock.classList.toggle("show")
  }

  return(
      <button
        className="link btn btnLight"
        onClick={toggleBookingForm}
      >
        <span>{locale === "en" ? "Book now" : "Réserver" }</span>
      </button>
  )
}

export default BookButton
